import React from 'react';

/* Heading */
const MainHeading = ({ mainHeading, classes = 'font-fig-extrabold text-3xl leading-tight text-gray-900' }) => {
  return <h3 className={'mb-0 ' + (classes) }>{mainHeading}</h3>;
};

export default MainHeading;
